import { axios } from '@Root/API'

export const getAll = (engagementId, params) => {
	return axios.get(`student-engagement/${engagementId}/collaborative-provision`, { params })
}
